import { ModalWithTransition } from '@studiometa/ui';

/**
 * Modal component
 * @param  {Class} SliderCore
 * @returns {void}
 */
export default class Modal extends ModalWithTransition {
  static config = {
    component: {
      Modal: ModalWithTransition,
    },
  };

  /**
   * Listen open/close event
   * @returns {void}
   */
  mounted() {
    this.$on('open', this.setAttr);
    this.$on('close', this.removeAttr);
  }

  /**
   * Add Z index to parent component
   */
  setAttr() {
    this.$el.style.zIndex = '99';
  }

  /**
   * Remove z-index property
   * @returns {void}
   */
  removeAttr() {
    this.$el.style.zIndex = '1';
  }
}
